import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { GetVoiceAllCallListAnsweredService, UpdateVoiceAllCallListAnsweredMassService, UpdateVoiceAllCallListAnsweredService } from './admin/VoiceCallListServices';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import DashboardMenu from '../screens/dashboard/DashboardMenu';
import { DatePicker } from 'antd';
import { AiOutlineEdit } from 'react-icons/ai';

function VoiceCallListAssignedAnswered() {

  const navigator = useNavigate()

  const {state} = useLocation()


  const [data,setdata] = useState({})

  const [search,setsearch] = useState({from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [page,setpage] = useState(1)



  useEffect(() => {
    getdata()
  }, [page])

  async function getdata() {
    const response = await GetVoiceAllCallListAnsweredService(page,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function updatefunc(d){
    await UpdateVoiceAllCallListAnsweredService(d?._id)
    const response = await GetVoiceAllCallListAnsweredService(page,search?.from_date1,search?.to_date1)
    setdata(response?.data)
    navigator('/dashboard/our_clients/edit',{state:d?.customer})
  }

  async function updateMass() {
    await UpdateVoiceAllCallListAnsweredMassService()
    const response = await GetVoiceAllCallListAnsweredService(page,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

   

      <div className='md:flex'>
        <div>
          <DashboardMenu  />
        </div>
        <div className='md:w-[90%] pl-2 mt-2'>

          <div className='md:flex items-center border-b justify-between pb-1'>
            <div className='flex flex-wrap items-center w-full  justify-between'>
            <h6 className='font-[800] text-[13px]'>VoiceCall Target Customer ({data?.pagination?.total})</h6>

            <div className='flex items-center'>
              <div className='flex items-center'>

              {data?.datas?.length > 0  && <h6 className='mr-2 text-[12px] font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>}

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              <h6 onClick={updateMass} className='bg-slate-100 cursor-pointer border rounded font-[600] w-max border-slate-300 text-[9px] px-1 py-1 '>Mark All Checked</h6>
            </div>
           
            </div>
          
          </div>


         
          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Info</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Status</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[300px] w-[300px]  px-2 py-1 font-[600] text-slate-800 border-r'>Campaign Info</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Action</h6>

                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{i + 1}</h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.customer?.name}</span>

                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[120px] w-[120px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.customer?.mobile}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.status}
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[300px] w-[300px]  px-2 py-1 font-[500] border-r'>
                         Campaign Info : <span className='font-[800]'>{d?.voice_call_list?.campaign_type}</span><br></br>
                         <div className='bg-blue-100 p-1'>
                          Campaign Name : <span className='font-[800]'>{d?.voice_call_list?.campaign_name}</span><br></br>
                          Campaign Id : <span className='font-[800]'>{d?.voice_call_list?.Campaign_id}</span><br></br>
                          </div>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>
                         <AiOutlineEdit onClick={()=>updatefunc(d)} />
                      </h6>


                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.customer?.name}</h6>
                          <h6 className='text-[11px] text-slate-600'>{d?.customer?.mobile}</h6>
                        </div>
                        <span className='p-2 -mr-1.5 cursor-pointer'><AiOutlineEdit size={17} onClick={()=>updatefunc(d)} /></span>
                      </div>

                      {d?.status && <h6 className='text-[10px] w-max bg-slate-100 px-1.5 py-0.5 rounded mt-1 capitalize'>{d?.status}</h6>}

                      <div className='bg-blue-50 rounded p-2 mt-2 text-[11px]'>
                        <h6>Campaign Type : <span className='font-[700]'>{d?.voice_call_list?.campaign_type}</span></h6>
                        <h6>Campaign Name : <span className='font-[700]'>{d?.voice_call_list?.campaign_name}</span></h6>
                        <h6>Campaign Id : <span className='font-[700]'>{d?.voice_call_list?.Campaign_id}</span></h6>
                      </div>
                    </div>
                  ))}
                </div>
                </>
                }
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default VoiceCallListAssignedAnswered